"use client"

import { useState } from "react"
import { useTranslations } from "next-intl"
import { PublicNavGlass } from "@/components/public-nav-glass"
import { ClientFooter } from "@/components/client/client-footer"
import { WaitlistModal } from "@/components/waitlist-modal"
import { LegalDocumentBody, type LegalDocument } from "@/components/legal/legal-document"

// Text in messages/pages/privacy.{en,es}.json, rendered by the shared legal
// renderer. Was hardcoded English at every locale.
//
// Two corrections went in with the extraction: the processor list named only
// some of what the app actually runs (Vercel's site analytics was missing, and
// a privacy policy has to name every processor), and "Payment Information"
// still described a barber Bookings subscription that was removed on
// 2026-09-26.
//
// The list is the contract: if you add or drop a processor, edit it in the same
// change. Meta and TikTok were added 2026-10-05, having been live and
// undisclosed; Sentry was never actually added here and the dead SDK it refers
// to was removed the same day.
export default function PrivacyPage() {
  const [waitlistOpen, setWaitlistOpen] = useState(false)
  const t = useTranslations("pages.privacy")
  const doc = {
    title: t("title"),
    lastUpdated: t("lastUpdated"),
    translationNote: t.has("translationNote") ? t("translationNote") : undefined,
    sections: t.raw("sections"),
  } as LegalDocument

  return (
    <div className="min-h-screen bg-background md:pt-14">
      <PublicNavGlass defaultMode="light" showModeToggle={false} />
      <WaitlistModal open={waitlistOpen} onOpenChange={setWaitlistOpen} />

      <main className="max-w-3xl mx-auto px-4 pt-24 pb-12 md:pt-12">
        <LegalDocumentBody doc={doc} />
      </main>

      <ClientFooter />
    </div>
  )
}
